if (!customElements.get(`product-info`)) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();

      this.stickyFrame = null;
      this.setStickyHeight = this.setStickyHeight.bind(this);
      this.onSectionLoad = (event) => {
        if (!event.target?.classList?.contains('section-product-details') &&
            !event.target?.classList?.contains('section-main-product')) return;
        this.setStickyHeight();
      };
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.isEnabledStickyContent = this.dataset.enabledStickyContent === 'true';
      if (!this.isEnabledStickyContent) return;

      this.variantEvent = `${PRODUCT_EVENT.updatedVariant}${this.sectionId}`;
      this.inDesignMode = Boolean(window.Shopify?.designMode);
      this.setStickyHeight();
      window.addEventListener('resize', this.setStickyHeight);
      document.addEventListener(this.variantEvent, this.setStickyHeight);
      if (this.inDesignMode) {
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        document.addEventListener('shopify:section:reorder', this.setStickyHeight);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.setStickyHeight);
      if (this.variantEvent) document.removeEventListener(this.variantEvent, this.setStickyHeight);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      document.removeEventListener('shopify:section:reorder', this.setStickyHeight);
      if (this.stickyFrame !== null) cancelAnimationFrame(this.stickyFrame);
      this.stickyFrame = null;
    }

    setStickyHeight() {
      if (!this.isConnected || !this.isEnabledStickyContent || this.stickyFrame !== null) return;
      this.stickyFrame = requestAnimationFrame(() => {
        this.stickyFrame = null;
        if (!this.isConnected) return;
        const contentSideEle = this.querySelector(`.product-template__content-wrapper[data-section-id="${this.sectionId}"]`);
        if (!contentSideEle) return;
        if (window.innerWidth < MIN_DEVICE_WIDTH.tablet) {
          contentSideEle.style.minHeight = 'auto';
          return;
        }

        let totalHeightMediaSide = 0;
        document.querySelectorAll(`.product-template__media-wrapper[data-section-id="${this.sectionId}"], .section-main-product + .section-product-details product-details`).forEach((elem) => {
          totalHeightMediaSide += elem.getBoundingClientRect().height;
        });
        const contentSideContainerEle = contentSideEle.querySelector(`.product-template__content__container`);
        contentSideEle.style.minHeight = `${totalHeightMediaSide}px`;
        if (totalHeightMediaSide >= contentSideEle.getBoundingClientRect().height) {
          contentSideContainerEle?.classList.add(`md:sticky`);
        } else {
          contentSideContainerEle?.classList.remove(`md:sticky`);
        }
      });
    }
  }

  customElements.define(`product-info`, ProductInfo);
}
